<template>
  <el-dialog
    title="Crear Interaccion"
    ref="drawerInteractionForm"
    :visible.sync="showDialogVisibleNewInteraction"
    width="35%"
    :before-close="handleClose"
    :append-to-body="appendToBoddy"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="newInteractionForm"
      label-width="150px"
      class="demo-ruleForm"
      label-position="left"
    >
      <el-form-item label="Tipo de interaccion" prop="InteractionTemplateCode">
        <el-select
          v-model="model.InteractionTemplateCode"
          placeholder="Tipo de interaccion"
          clearable
          filterable
        >
          <el-option
            v-if="isVisit"
            :key="list_interaction_code_to_select[8].value"
            :label="list_interaction_code_to_select[8].label"
            :value="list_interaction_code_to_select[8].value"
          ></el-option>
          <el-option
            v-else-if="isInHours"
            :key="list_interaction_code_to_select[4].value"
            :label="list_interaction_code_to_select[4].label"
            :value="list_interaction_code_to_select[4].value"
          ></el-option>
          <el-option
            v-else-if="isCall"
            :key="list_interaction_code_to_select[3].value"
            :label="list_interaction_code_to_select[3].label"
            :value="list_interaction_code_to_select[3].value"
          >
          </el-option>
          <el-option
            v-else
            v-for="item in list_interaction_code_to_select"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="Producto" prop="ProductCode">
        <el-select
          clearable
          filterable
          default-first-option
          v-model="model.ProductCode"
          placeholder="Producto"
        >
          <el-option
            v-for="item in list_products"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="Inciada por" prop="InitiatedBy">
        <el-select
          v-model="model.InitiatedBy"
          placeholder="Inciada por"
          clearable
          filterable
        >
          <el-option
            v-for="item in model.InitiatedByItems"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="Contacto" prop="Code">
        <el-select
          v-model="model.Code"
          placeholder="Contacto"
          clearable
          filterable
        >
          <el-option
            v-for="item in listContact"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
          <!-- <el-option
            v-for="item in contactByCust"
            :key="item.ContactCode"
            :value="item.ContactCode"
            :label="item.Name"
          ></el-option> -->
        </el-select>
      </el-form-item>

      <el-form-item label="Objetivo" prop="Subject">
        <el-input v-model="model.Subject"></el-input>
      </el-form-item>

      <!-- <el-form-item label="Conclusion" prop="Description">
        <el-input v-model="model.Description" type="textarea"></el-input>
      </el-form-item> -->

      <el-row>
        <el-col>
          <h3>Descripción de la interacción</h3>
          <el-form-item label-width="0" prop="Description">
            <quill-editor
              ref="myQuillEditor"
              v-model="model.Description"
              style="height: auto; margin-bottom: 10px"
            ></quill-editor>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button
        type="primary"
        @click="submitForm('newInteractionForm')"
        v-loading="loading"
        >Crear</el-button
      >
      <el-button @click="handleClose">Cancelar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "DialogNewInteractionForm",
  props: {
    appendToBoddy: {
      type: Boolean,
      default: false,
      required: false
    },
    CustomerData: {
      type: Object
    },
    isCall: {
      type: Boolean
    },
    isVisit: {
      type: Boolean
    },
    isInHours: {
      type: Boolean
    },
    isItVisible: {
      type: Boolean,
      default: false,
      required: false
    },
    dealId: {
      type: Number,
      default: 0,
      required: false
    },
    isProspect: {
      type: Boolean,
      default: false,
      required: false
    },
    clientCode: {
      type: String,
      default: "",
      required: false
    }
  },
  components: {
    quillEditor
  },
  data() {
    return {
      contactByCust: "",
      showDialogVisibleNewInteraction: false,
      model: {
        Description: "",
        Subject: "",
        InteractionTemplateCode: "",
        ProductCode: "",
        InitiatedByItems: [
          {
            label: "Tennos Business",
            value: 0,
            IsEnable: true
          },
          {
            label: "Cliente / Contacto",
            value: 1,
            IsEnable: true
          }
        ],
        InitiatedBy: 0,
        ContactCode: "",
        Code: ""
      },
      model2: {
        Description: "",
        Subject: "",
        InteractionTemplateCode: "",
        ProductCode: "",
        InitiatedByItems: [
          {
            label: "Tennos Business",
            value: 0,
            IsEnable: true
          },
          {
            label: "Cliente / Contacto",
            value: 1,
            IsEnable: true
          }
        ],
        InitiatedBy: 0,
        ContactCode: "",
        Code: ""
      },
      rules: {
        InteractionTemplateCode: [{ required: true }],
        ProductCode: [{ required: true }],
        InitiatedBy: [{ required: true }],
        Code: [{ required: true }],
        Subject: [{ required: true }],
        Description: [
          {
            required: true,
            message: "La descripcion de la tarea es requerida",
            trigger: "change"
          }
        ]
      },
      companyId: this.$store.state.user.user.CompanySelected
    };
  },
  async mounted() {
    await this.getIterationList();
    await this.getAllProducts();

    if (this.isProspect) {
      await this.getByProspectCode({
        contactCode: this.clientCode
      });
    } else {
      await this.getByCustomerCode({
        customerCode: this.clientCode
      });
    }
  },
  computed: {
    ...mapGetters({
      listContact: "contact/list_to_select",
      list_interaction_code_to_select:
        "interactions/list_interaction_code_to_select",
      list_products: "products/list_products",
      loading: "contact/isLoading"
    }),
    isThisVisible() {
      return this.isItVisible;
    }
  },
  methods: {
    ...mapActions({
      getByCustomerCode: "contact/getByCustomerCode",
      getByProspectCode: "contact/getByProspectCode",
      getIterationList: "interactions/get_interaction_code",
      getAllProducts: "products/all"
    }),
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (this.model.Description == "") {
          this.$message({
            type: "error",
            message: "La Descripcion es requerida"
          });
        }
        if (valid) {
          const date = this.$now();
          this.$store
            .dispatch("interactions/create", {
              ContactNumber: this.model.Code,
              ContactCompanyNumber: this.clientCode,
              Date: date,
              Description: this.model.Description.replace("<p>", "").replace(
                "</p>",
                ""
              ),
              InitiatedBy: this.model.InitiatedBy,
              InteractionTemplate: this.model.InteractionTemplateCode,
              Subject: this.model.Subject,
              UserName: this.currentUser.UserName,
              Time: date,
              ProductCode: this.model.ProductCode,
              UserID: this.currentUser.UserID,
              CustomerServiceExec_: this.currentUser.CustomerServiceExec_,
              SalesPersonCode: this.CustomerData.SalesPersonCode,
              CompanyId: this.currentUser.CompanySelected,
              DealsId: this.dealId
            })
            .then(() => {
              this.showDialogVisibleNewInteraction = false;
              this.$emit("refreshInteraction");
              this.$message({
                type: "success",
                message: "Interaccion creada!"
              });
              this.resetForm("newInteractionForm");
            });
        } else {
          this.resetForm("newInteractionForm");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.showDialogVisibleNewInteraction = false;
      this.$emit("closeIteractionsDialog");
    },
    handleClose(done) {
      this.$refs["newInteractionForm"].resetFields();
      this.resetForm("newInteractionForm");
      this.$emit("closeIteractionsDialog");

      done();
    },
    show(clientCode, isProspect = false) {
      this.isProspect = isProspect;
      this.clientCode = clientCode;
      this.model = this.model2;
      this.showDialogVisibleNewInteraction = true;
    }
  },

  watch: {
    isInHours(val) {
      this.model2.InteractionTemplateCode = val == true ? "LLAMADA_SO" : "";
      this.model2.InitiatedBy = val == true ? 1 : 0;
    },
    clientCode(val) {
      if (this.isProspect) {
        this.getByProspectCode({
          contactCode: val
        });
      } else {
        this.getByCustomerCode({
          customerCode: val
        });
      }
    },
    listContact(val) {
      if (val.length <= 0) {
        this.$alert("Este prospecto no tiene contacto.", "", {
          type: "warning"
        });
        // this.showDialogVisibleNewInteraction = false;
      }
    },
    isThisVisible(val) {
      if (val) {
        this.model = this.model2;
      }

      this.showDialogVisibleNewInteraction = val;
    }
  }
};
</script>
